import { FC } from 'react';
import { Link } from 'react-router-dom';

import IconButton, { IconButtonProps } from 'components/_core/IconButton';

interface NavigationButtonProps {
  variant: 'back' | 'close';
  to?: string;
  onClick?: () => void;
}

const NavigationButton: FC<NavigationButtonProps> = ({
  onClick,
  to,
  variant,
}) => {
  const iconButtonProps: IconButtonProps = {
    'aria-label': '',
    icon: variant === 'back' ? 'arrow-left' : 'cross',
    onClick: onClick,
    variant: 'secondary',
  };

  if (to) {
    return <IconButton {...iconButtonProps} as={Link} to={to} />;
  }

  return <IconButton {...iconButtonProps} />;
};

export default NavigationButton;
